
const state = {
  message: {
    text: 'i am an alert',
    type: 'error',
    alert: false
  }
}

const getters = {
}

const mutations = {
  setMessage (state, message) {
    state.message = message
    setTimeout(function () {
      state.message = {
        text: 'i am an alert',
        type: 'error',
        alert: false
      }
    }, 3000)
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}
